module.exports = __webpack_public_path__ + "static/img/salepage-stk-product_03.ff350c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/products/salepage-stk-product_03.jpg
// module id = Oldv
// module chunks = 134